import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import { useSpawnParticipantCall } from 'features/call/call-accepted/hooks';
import { isDeafToHearingSelector } from 'features/call/call-base/store/selectors';
import {
  AddCallee,
  CallDetailsParticipant,
} from 'features/call/call-details/components';
import { useCallDetailsCaller } from 'features/call/call-details/hooks';
import { Separator } from 'features/call/call-details/styles';
import { CustomGreeting } from 'features/custom-greeting/components';
import theme from 'features/theme/theme';

export const CallDetailsCalleeDisconnectedFast: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'callDetails' });
  const { caller } = useCallDetailsCaller();
  const isDeafToHearing = useAppSelector(isDeafToHearingSelector);
  const {
    handleSpawnNewCall,
    isLoading: isSpawnCallLoading,
    title: spawnCallTitle,
  } = useSpawnParticipantCall();

  return (
    <>
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <Separator />
      <Typography variant='label' color={theme.palette.grey[300]} mb={4}>
        {t('callTo')}
      </Typography>
      <AddCallee
        title={spawnCallTitle}
        onClick={handleSpawnNewCall}
        isLoading={isSpawnCallLoading}
        showExtensionInput={isDeafToHearing}
      />
    </>
  );
};
